// src/api/modules/PickupApi.js
import Methods from "../methods";

const searchPickups = (context, idClient, payload) => {
  const {filters, page, size, sortBy = "pickupRegisterDate", direction = "desc"} = payload;
  const url = `/pickups/search/${idClient}?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;
  return Methods.doPost(context, url, filters, null);
};

export default {
  searchPickups,
};



// WEBPACK FOOTER //
// ./src/api/modules/PickupApi.js